var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle])},[_c('tag-list',{attrs:{"value":_vm.props.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }